import { render, staticRenderFns } from "./RoutePoint.vue?vue&type=template&id=0f173b9a&"
import script from "./RoutePoint.vue?vue&type=script&lang=js&"
export * from "./RoutePoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f173b9a')) {
      api.createRecord('0f173b9a', component.options)
    } else {
      api.reload('0f173b9a', component.options)
    }
    module.hot.accept("./RoutePoint.vue?vue&type=template&id=0f173b9a&", function () {
      api.rerender('0f173b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/points/RoutePoint.vue"
export default component.exports